<div class="main-content" [ngClass]="{'hide': !visible}">
  <div class="content">
    <div class="text-container">
      <div class="title">Welcome back {{userdata?.full_name?.trim()}}</div>
      <div class="text">You’ve helped save {{userdata?.aggdonationall?.funds}} {{ userdata?.aggdonationall?.funds === 1 ? 'life' : 'lives'}} till now. Keep up the good work!</div>
    </div>
    <img class="heart" loading="lazy" [attr.data-src]="'/assets/images/red_heart.png'" [default]="util.defaultImg" alt="heart">
  </div>
</div>